import React, {useState} from 'react'
import AppLayout from '@/Layouts/AppLayout'
import OrganizationLayout from '@/Layouts/OrganizationLayout'
import {Container} from "@/Components";
import {OnboardingSteps} from "@/Pages/Organization/Onboarding/Partials/Steps";
import {LabeledInput} from "@/Components/Form";
import {Inertia} from "@inertiajs/inertia";
import {ROLE_ID} from "@/Enums/roles";
import {ErrorMessage} from "@/Components/Messages";

export default function OnboardingReporters({
  errors,
  team
}) {

  let [dirty, setDirty] = useState(false)
  let [disableForm, setDisableForm] = useState(false)
  let [values, setValues] = useState({
    firstname: "",
    surname: "",
    email: "",
    phone: ""
  });

  let [createdReporters, setCreatedReporters] = useState([]);

  function handleSave(e) {
    e.preventDefault()

    if (disableForm) return false;
    if (!dirty) return false;

    setDisableForm(true);

    let data = {
      ...values,
      role: ROLE_ID.REPORTER,
      team_id: team.data.id
    };

    Inertia.post('/users/create', data, {
      onSuccess: () => {
        setCreatedReporters([...createdReporters, {firstname: values.firstname, surname: values.surname}]);

        setValues({
          firstname: "",
          surname: "",
          email: "",
          phone: ""
        });
      },
      onFinish: () => (setDisableForm(false))
    });
  }

  function completeOnboarding() {
    Inertia.post('/organization/onboarding/complete');
  }

  function handleUpdate(event) {

    setValues( prevValues => {
      return { ...prevValues,[event.target.name]: event.target.value}
    });

    setDirty(true);
  }

  function SettingsSaveButton() {
    let disabled = false;

    if (!dirty || disableForm) {
      disabled = true;
    }

    if(!values.firstname || !values.surname || !values.email || !values.phone) {
      disabled = true;
    }

    return <button
      disabled={disabled}
      onClick={handleSave}
      className="self-end ml-3 btn"
    >
      Add reporter
    </button>
  }


  return <>

    <OnboardingSteps currentStep={2} steps={['Reporting', 'Activities', 'Reporters']}/>

    <h4 className="text-xl mb-4 font-bold">Create some reporters</h4>

    <Container padding="" className="md:dots-orange md:dots-orange--no-top-overflow relative z-10">

      {createdReporters && createdReporters.map((reporter, index) => (
          <div key={index} className="flex flex-row items-center mb-2 border border-gray-200 px-4 py-3 flex bg-white">
              <p>{reporter.firstname} {reporter.surname}</p>
              <span className="text-sm ml-3 px-4 py-2 border border-gray-lighter shadow-sm">Reporter</span>
          </div>
        )
      )}

        <form className="w-full flex flex-row flex-wrap bg-white p-8 mt-4" >

          {errors && errors.message && (
            <ErrorMessage className="mb-8">{errors.message}</ErrorMessage>
          )}

          <div className="w-full mb-4">
            <LabeledInput
              title="First name*"
              name="firstname"
              type="text"
              required="required"
              placeholder="Enter first name"
              value={values.firstname}
              onChange={handleUpdate}
              error={errors && errors.firstname}
            />
          </div>

          <div className="w-full mb-4">
            <LabeledInput
              title="Surname*"
              name="surname"
              type="text"
              required="required"
              placeholder="Enter surname"
              value={values.surname}
              onChange={handleUpdate}
              error={errors && errors.surname}
            />
          </div>

          <div className="w-full mb-4">
            <LabeledInput
              title="Contact e-mail*"
              name="email"
              type="email"
              required="required"
              placeholder="Enter e-mail"
              value={values.email}
              onChange={handleUpdate}
              error={errors && errors.email}
            />
          </div>

          <div className="w-full mb-4">
            <LabeledInput
              title="Contact phone number*"
              name="phone"
              type="text"
              required="required"
              placeholder="Enter phone number"
              value={values.phone}
              onChange={handleUpdate}
              error={errors && errors.phone}
            />
          </div>

          <div className="flex justify-end w-full">
            <SettingsSaveButton/>
          </div>
        </form>
      </Container>

      <div className="flex justify-end w-full mt-4 mb-16">
        <a className="text-blue underline py-4 cursor-pointer" onClick={completeOnboarding} >
          Skip
        </a>
        <button
          className="self-end ml-3 btn"
          onClick={completeOnboarding}
        >
          Start emission accounting
        </button>
      </div>

  </>

}

OnboardingReporters.layout = page => (
  <AppLayout title="Onboarding - Reporters">
    <OrganizationLayout header="">
      {page}
    </OrganizationLayout>
  </AppLayout>
)
